

const addSkipPicker = (pn, picker) => {
    const data = window.store.getState().dashboard?.bffDashboardData?.data;
    console.info(`>>>addSkipPicker pn ${pn} picker, data`, picker, data);
    switch (pn) {
        case 'messages':
            if (data?.myChartStatus) {
                picker.skipPicker = () => {
                    console.info(`???picker messages`);
                    let skip = false;
                    //if no proxies skip
                    if (data.myChartStatus.isPatient && data.patients.length === 1) {
                        console.info(`???picker messages no proxies skip`);
                        skip = true;
                    }
                    //if non patient and one proxy skip
                    if (!data.myChartStatus.isPatient && data.patients.length === 2) {
                        console.info(`???picker messages non patient and one proxy skip`);
                        skip = true;
                    }
                    return skip;
                }
            } else {
                picker.skipPicker = () => { return false; }
            }
            break;
        default:
            picker.skipPicker = () => { return false; }
            break;
    }
    return picker;
}

export default addSkipPicker;